// ============================================
// SUCCESSMODAL.JS - Confirmación de Login
// ============================================

import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { lockScroll, unlockScroll } from 'utils/scrollLock';
import './SuccessModal.css';

// Ícono de check animado
const CheckIcon = () => (
  <svg
    className="success-check"
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      className="success-check-circle"
      cx="26"
      cy="26"
      r="25"
      fill="none"
    />
    <path
      className="success-check-path"
      fill="none"
      d="M14.1 27.2l7.1 7.2 16.7-16.8"
    />
  </svg>
);

export default function SuccessModal({ 
  isOpen, 
  onClose, 
  userName = "Usuario",
  onGoToAccount,
  onContinueShopping 
}) {
  const navigate = useNavigate();

  // Continuar explorando (quedarse en la página actual)
  const handleContinue = useCallback(() => {
    if (onContinueShopping) {
      onContinueShopping();
    } else {
      onClose();
    }
  }, [onClose, onContinueShopping]);

  // Ir a Mi Cuenta
  const handleGoToAccount = useCallback(() => {
    onClose();
    if (onGoToAccount) {
      onGoToAccount();
    } else {
      navigate('/my-account');
    }
  }, [onClose, onGoToAccount, navigate]);

  // Bloquear scroll cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return () => { unlockScroll(); };
  }, [isOpen]);

  // Cerrar con tecla ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        handleContinue();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleContinue]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay con blur */}
      <div
        className="success-overlay"
        onClick={handleContinue}
        aria-hidden="true"
      />

      {/* Modal de éxito */}
      <div
        className="success-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-title"
      >
        <div className="success-content">
          {/* Ícono de check animado */}
          <CheckIcon />

          {/* Título */}
          <h2 id="success-title" className="success-title">
            ¡Bienvenido de vuelta!
          </h2>

          {/* Nombre del usuario */}
          <p className="success-username">{userName}</p>

          {/* Mensaje */}
          <p className="success-message">
            Has iniciado sesión correctamente en tu cuenta.
          </p>

          {/* Botones de acción */}
          <div className="success-actions">
            <button
              className="success-btn success-btn-primary"
              onClick={handleGoToAccount}
            >
              IR A MI CUENTA
            </button>

            <button
              className="success-btn success-btn-secondary"
              onClick={handleContinue}
            >
              SEGUIR EXPLORANDO
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
